import { authFetch } from "./authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function getProjectNodeQr(nodeId, signal, includeFiles = false) {
  const response = await authFetch(`${BACKEND_URL}/project/qr/node/${encodeURIComponent(nodeId)}${includeFiles ? "?files=1" : ""}`, { method: "GET", signal });
  const result = await response.json().catch(() => null);
  return { ...result, success: response.ok && result?.success === true, status: response.status };
}

export async function issueProjectNodeQr(nodeId, signal) {
  const response = await authFetch(`${BACKEND_URL}/project/qr/node/${encodeURIComponent(nodeId)}`, { method: "POST", signal });
  const result = await response.json().catch(() => null);
  return { ...result, success: response.ok && result?.success === true, status: response.status };
}
